import i18n from '@/js/plugins/i18n';
import useUiMsgboxStore from '@/stores/ui/msgbox';

function formatDependencyElementsList(elements) {
  const $t = i18n.global.t;
  return elements.map((el) => {
    const elementTypeText = $t(el.isType('milestone') ? 'GLOBAL.MILESTONE' : 'GLOBAL.BUBBLE');
    const elementTitle = el.getTitle() || $t('helpers.elDefaultTitle', { type: el.getType() });
    return `<div>- ${elementTypeText} « ${elementTitle} »</div>`;
  }).join('');
}

function openReduceElDependenciesDialog(reducedElements, direction = 'successors') {
  const $t = i18n.global.t;
  const uiMsgboxStore = useUiMsgboxStore();
  const isPredecessors = direction == 'predecessors';
  const size = reducedElements?.size || 0;
  let body;
  let hasChanges = false;
  if (! size) {
    body = isPredecessors ? $t('DEPENDENCIES.NO_PREDECESSORS_TO_REDUCE') : $t('DEPENDENCIES.NO_SUCCESSORS_TO_REDUCE');
  } else {
    body = formatDependencyElementsList([...reducedElements]);
    hasChanges = true;
  }

  const msgbox = uiMsgboxStore.open({
    title: isPredecessors ? $t('DEPENDENCIES.REDUCE_ELEMENT_PREDECESSORS_CONFIRMATION_TITLE', size) : $t('DEPENDENCIES.REDUCE_ELEMENT_SUCCESSORS_CONFIRMATION_TITLE', size),
    body,
    buttons: hasChanges ? { ok: 'GLOBAL.OK', cancel: 'GLOBAL.CANCEL' } : { ok: 'GLOBAL.OK' },
  });

  return {
    hasChanges,
    msgbox,
  };
}

function openDependenciesConflictError(relatedElsById) {
  const $t = i18n.global.t;
  const uiMsgboxStore = useUiMsgboxStore();
  const conflictingElements = [];
  relatedElsById.forEach((el) => {
    if (el.constrainingLockedElement || el.optimizedDependencyElement || el.changed) {
      conflictingElements.push(el);
    }
  });

  let body = $t('DEPENDENCIES.CANNOT_BE_RESOLVED');
  if (conflictingElements.length) {
    body = `${body}${formatDependencyElementsList(conflictingElements)}`;
  }

  uiMsgboxStore.open({
    title: $t('DEPENDENCIES.ERROR_WITH_DEPENDENCIES'),
    body,
  });
}

function openConstraintMessage(changedTriggerEl) {
  const $t = i18n.global.t;
  const uiMsgboxStore = useUiMsgboxStore();
  const { constrainingLockedElement, optimizedDependencyElement } = changedTriggerEl;

  if (optimizedDependencyElement) {
    uiMsgboxStore.open({
      title: $t('DEPENDENCIES.DEPENDENCY_ELEMENT'),
      body: $t('DEPENDENCIES.MOVE_LIMITED_BY_DEPENDENCY_ELEMENTS', {
        dependencyEl: optimizedDependencyElement?.getTitle(),
        dependencyElDate: optimizedDependencyElement?.getStartTime().format('L'),
      }),
    });
    return;
  }

  uiMsgboxStore.open({
    title: $t('DEPENDENCIES.LOCKED_ELEMENT'),
    body: $t('DEPENDENCIES.MOVE_LIMITED_BY_LOCKED_ELEMENTS', {
      lockedEl: constrainingLockedElement?.getTitle(),
      lockedElDate: constrainingLockedElement?.getStartTime().format('L'),
    }),
  });
}

export {
  openReduceElDependenciesDialog,
  openDependenciesConflictError,
  openConstraintMessage,
};
